import { LEGAL_DOCUMENT_ALLOWED_TAGS, LEGAL_DOCUMENT_CONTENT_CLASS } from "@/features/legal/config/legal.config";
import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";
import { HtmlContentModal } from "@/shared/components/HtmlContentModal/HtmlContentModal";
import { useSanitizedHtml } from "@/shared/hooks/useSanitizedHtml";

type LegalDocumentModalProps = {
  document: LegalDocument | null
  onClose: () => void
};

// Shows a notice frozen with the publication in place, so reading it never
// leaves the login step.
export const LegalDocumentModal = ({ document, onClose }: LegalDocumentModalProps) => {
  const html = useSanitizedHtml(document?.body_html, { allowedTags: LEGAL_DOCUMENT_ALLOWED_TAGS });

  return (
    <HtmlContentModal
      show={document !== null}
      onClose={onClose}
      title={document?.title ?? ""}
      html={html}
      contentClassName={LEGAL_DOCUMENT_CONTENT_CLASS}
    />
  );
};

LegalDocumentModal.displayName = "LegalDocumentModal";
